import type { InfiniteData } from 'react-query';
import type { PageType, PhotoCardType, SelectedCollectedData } from '../../../types/PhotoCardType';

export const getMemberId = (photoCard: PhotoCardType, currentMember: { memberId: string }) => {
  return photoCard.memberId || currentMember?.memberId;
};

// 원본 데이터에서 원본 카운트를 가져오는 함수
export const getOriginalCollectedCount = (
  data: InfiniteData<PageType>,
  photoCard: PhotoCardType
) => {
  const original = data?.pages
    ?.flatMap((page) => page.events || [])
    ?.flatMap((event) => event.photoCards || [])
    ?.find((pc) => pc.photoCardId === photoCard.photoCardId);

  return original?.collectedCount || 0;
};

interface TransformPaginatedEventsProps {
  newPaginatedData: InfiniteData<PageType>['pages'];
  updatedCollectedData: SelectedCollectedData;
  selectedCollectedData: SelectedCollectedData;
}

// 페이지 데이터를 변환하는 함수
export const transformPaginatedEvents = ({
  newPaginatedData,
  updatedCollectedData,
  selectedCollectedData
}: TransformPaginatedEventsProps) => {
  return newPaginatedData.flatMap((page) =>
    page.events.map((event) => {
      const newEvent = {
        ...event,
        photoCards: event?.photoCards?.map((photoCard) => {
          const memberId = photoCard.memberId;

          // 원본 상태 결정
          let originalCount = photoCard.collectedCount;
          if (updatedCollectedData[memberId]?.[photoCard.photoCardId]) {
            originalCount = updatedCollectedData[memberId][photoCard.photoCardId]?.collectedCount;
          }

          // 현재 표시할 상태 결정
          let newCollectedCount = originalCount;
          if (selectedCollectedData[memberId]?.[photoCard.photoCardId]) {
            newCollectedCount =
              selectedCollectedData[memberId][photoCard.photoCardId]?.collectedCount;
          }

          return {
            ...photoCard,
            originalCollectedCount: originalCount,
            collectedCount: newCollectedCount
          };
        })
      };
      return newEvent;
    })
  );
};

// 선택된 데이터에서 특정 포카 데이터를 제거하는 함수
export const removeFromSelectedData = (
  data: SelectedCollectedData,
  memberId: string,
  photoCardId: string
) => {
  const newData = { ...data };

  if (newData[memberId]?.[photoCardId]) {
    delete newData[memberId][photoCardId];

    // 빈 멤버 객체 제거
    if (Object.keys(newData[memberId]).length === 0) {
      delete newData[memberId];
    }
  }

  return newData;
};

export const updatePhotoCardWithPrevData = (
  prevData: SelectedCollectedData,
  photoCard: PhotoCardType,
  memberId: string
) => {
  return {
    ...prevData,
    [memberId]: {
      ...prevData[memberId],
      [photoCard.photoCardId]: {
        ...prevData[memberId]?.[photoCard.photoCardId],
        collectedCount: photoCard.collectedCount
      }
    }
  };
};
